module.exports = __webpack_public_path__ + "static/media/scoli-shoulder-2m.7eb12c20.png";